import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrashCan } from "@fortawesome/pro-solid-svg-icons";
import { AdminListCard, type BatchAction } from "@components/CatalogIndex";
import type { Calculation } from "./types";
import "./style.css";

export interface CalculationsListProps {
  rows: Calculation[];
  selectedIds: string[];
  setSelectedIds: (ids: string[]) => void;
  onAdd: () => void;
  onEdit: (calc: Calculation) => void;
  onBatchDelete: () => void;
}

export const CalculationsList = ({
  rows,
  selectedIds,
  setSelectedIds,
  onAdd,
  onEdit,
  onBatchDelete,
}: CalculationsListProps): JSX.Element => {
  const toggle = (id: string) =>
    setSelectedIds(
      selectedIds.includes(id)
        ? selectedIds.filter((x) => x !== id)
        : [...selectedIds, id]
    );

  const batchActions: BatchAction[] = [
    {
      icon: faTrashCan,
      label: "Delete",
      onClick: onBatchDelete,
      variant: "danger",
    },
  ];

  return (
    <AdminListCard
      title="Survey Calculations"
      bare
      isEmpty={rows.length === 0}
      emptyMessage="No calculations yet."
      onNew={onAdd}
      newButtonLabel="Add Calculation"
      batchActions={batchActions}
      selectedCount={selectedIds.length}
    >
      <table className="calculations-table">
        <thead>
          <tr>
            <th className="select-col" />
            <th>Name</th>
            <th>Expression</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((c) => (
            <tr key={c.id}>
              <td>
                <input
                  type="checkbox"
                  style={{ accentColor: "#418172" }}
                  aria-label={`Select calculation ${c.name}`}
                  checked={selectedIds.includes(c.id)}
                  onChange={() => toggle(c.id)}
                />
              </td>
              <td>
                <button
                  type="button"
                  className="adminListEditLink calc-edit-link"
                  onClick={() => onEdit(c)}
                >
                  {c.name}
                  <FontAwesomeIcon
                    icon={faPencil}
                    className="adminListEditLink__icon"
                  />
                </button>
              </td>
              <td>{c.expression}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminListCard>
  );
};

export default CalculationsList;
